<template>
    <div class="content">
        <h1>SKILLS</h1>
        <h2>Web-Entwicklung</h2>
        <p>
            Fließender Umgang mit <b>HTML5</b><br>
            Fließender Umgang mit <b>JavaScript</b><br>
            Fließender Umgang mit <b>jQuery</b><br>
            Fließender Umgang mit <b>Vue.js</b><br>
            Fließender Umgang mit <b>Vue CLI 3</b><br>
            Fließender Umgang mit <b>Quasar</b><br>
            Fließender Umgang mit <b>CSS 3</b><br>
            Fließender Umgang mit <b>PHP</b><br>
            Sehr gute Kenntnisse <b>Bootstrap</b><br>
            Sehr gute Kenntnisse <b>SASS</b><br>
            Sehr gute Kenntnisse <b>RWD</b><br>
            Sehr gute Kenntnisse <b>node.js, npm</b><br>
            Sehr gute Kenntnisse <b>XML</b><br>
            Sehr gute Kenntnisse <b>Bitbucket</b><br>
            Sehr gute Kenntnisse <b>Bamboo</b><br>
            Gute Kenntnisse <b>Docker</b><br>
            Gute Kenntnisse <b>Typo3</b><br>
            Mehrjährige Implementierungs-Erfahrung mit verschiedenen externen Anbietern <b>PCI-zertifizierter Zahlungssysteme</b>
            (z.B. <b>Wirecard</b>, <b>Synaix PCI</b>)
        </p>
        <h2>Objektorientierte Programmierung</h2>
        <p>
            Fließender Umgang mit <b>PHP</b><br>
            Sehr gute Kenntnisse <b>C# .NET</b><br>
            Gute Kenntnisse <b>C++</b><br>
            Gute Kenntnisse <b>VB .NET</b>
        </p>
        <h2>Prozedurale Programmierung</h2>
        <p>
            Sehr gute Kenntnisse <b>C</b><br>
            Sehr gute Kenntnisse <b>G</b> unter <b>LabVIEW</b>
        </p>
        <h2>Datenbanken</h2>
        <p>
            Sehr gute Kenntnisse <b>MySQL</b><br>
            Gute Kenntnisse <b>MS SQL Server</b><br>
            Gute Kenntnisse <b>relationale Datenbanken</b><br>
            Grundkenntnisse <b>Caché Server</b><br>
            Grundkenntnisse <b>Oracle Server</b>
        </p>
        <h2>Netzwerke</h2>
        <p>
            Gute Kenntnisse <b>MS Windows-Netzwerke</b><br>
            Grundkenntnisse <b>Linux-Netzwerke</b>
        </p>
        <h2>Fremdsprachen</h2>
        <p>
            Sehr gute Kenntnisse <b>Englisch</b><br>
            Grundkenntnisse <b>Französisch</b><br>
            <b>Latinum</b>
        </p>
        <h2>Führerschein</h2>
        <p>
            Klasse <b>III</b>
        </p>
        <h2>Sonstiges</h2>
        <p>
            Fließender Umgang mit <b>E-Mail, Internet</b> und <b>E-Commerce</b>
        </p>
    </div>
</template>

<script>
export default {
    name: 'skills',
    methods: {
        emitLogData(page, action) {
            this.$emit(
                'log-it',
                '{"page": "' + page + '", "action": "' + action + '"}'
            );
        }
    },
    mounted() {
        this.emitLogData('confirmation', 'visit');
    },
    beforeDestroy() {
        this.emitLogData('confirmation', 'leave');
    }
};
</script>

<style lang="scss" scoped>
    .p-item {
        margin: 20px 0 !important;
    }
</style>
